const INFO = {
	main: {
		title: "Portfolio of Muthuraman",
		name: "Muthuraman .P",
		email: "muthucube@gmail.com",
		logo: "../logo.png",
		mobile: "+91 98848 44176"
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/MuthuramanP",
		linkedin: "https://www.linkedin.com/in/muthuraman-piramanayagam-035163179/",
		instagram: "https://instagram.com/",
		youtube: "http://www.youtube.com/c/VAPStudent",
	},

	homepage: {
		title: "Full Stack web and Rest API developer.",
		description:
			`I am a Full Stack developer with expertise in React, Angular and Node.js with PostgreSQL or MySQL DB. 
			I have experience in building scalable, secure and reliable web applications using various frameworks and technologies. 
			I enjoy solving complex problems and learning new skills. 
			I am passionate about creating high-quality code that follows best practices and industry standards. 
			I am always looking for new challenges and opportunities to grow as a developer.`,
	},

	about: {
		title: "I'm Muthuraman .P, having 22+ years of IT experience.",
		description:
			`I've worked on a variety of projects over the years and I'm proud of the progress I've made. 
			Many of these projects are open-source and available for others to explore.
			 If you're interested in any of the projects I've worked on, please feel free to check out the code 
			 and suggest any improvements or enhancements you might have in mind. 
			Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.
			`,
		more_desc: `Recently working in Gen AI with Full stack application (React, Angular, NodeJS with MYSQL, Mongo DB, PostgreSQL) in 
		Document Chat (Ollama Models) and Health Care application HL7, Mirth Connect, FHIR, EPIC`
	},

	articles: {
		title: `Sr.Manager - Technical Architect. GenAI | Full Stack | DB | Flutter`,
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "PERN Stack (ReactJS)",
			description:
				`Our application is built to streamline donor management for charity organizations. 
				It helps administrators efficiently maintain donor information, track contributions, 
				and manage expenses — all in one place. Developed using React.js, Node.js, and PostgreSQL for speed, 
				scalability, and reliability.`,
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "VAP Student",
			link: "https://vapstudent.in/",
		},
		{
			title: "MEAN Stack (Angular)",
			description:
				`This application is designed to manage and maintain student information for martial arts academies. 
				It provides administrators and instructors with a streamlined way to handle student records 
				and academy operations. Developed using Angular, Node.js, and MySQL for speed, 
				scalability, and reliability.`,
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/typescript/typescript.png",
			linkText: "VAP Student",
			link: "https://vapstudent.in/",
		},

		{
			title: "Gen AI",
			description:
				`DataGPT is the application, that lets users create private, customizable AI assistants powered 
				by large language models (LLMs) like OpenAI's GPT, Local LLMs models. 
				Its key strength is the ability to ingest and interact with your own data, making it great for internal knowledge 
				bases or personal AI tools.`,
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "VAP Student",
			link: "https://vapstudent.in/",
		},

		{
			title: "Websites",
			description:
				`Created many websites for me as well as for some clients. Which is mainly in Angular, React and plain HTML, CSS and JavaScript.
				Those are deployed in the client server and regularly update as per client's change request.`,
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/html/html.png",
			linkText: "VAP Student",
			link: "https://vapstudent.in/",
		},
		{
			title: "Rest API",
			description:
				`Created good structured NodeJS Rest API for various application with JWT token for security purpose and 
				connected DB like MYSQL or PostgreSQL to maintain the data`,
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "VAP Student",
			link: "https://vapstudent.in/",
		},

		{
			title: "Youtube Channel",
			description:
				`I have my own youtube channel (VAP Student) and teaching latest technology in computer programming like 
				HTML, CSS, JavaScript, OOPS, React, Angular,  NodeJS, MySQL and PostgreSQL in free of cost for students who really need & interest`,
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/typescript/typescript.png",
			linkText: "VAP Student",
			link: "https://vapstudent.in/",
		},
	],
};

export default INFO;
